componentRegistryInstance.register('multiple-date', 'edit', 'hrd.components.form.MultipleDateComponent');

hrd.components.form.MultipleDateComponent = hrd.components.AbstractFieldComponent.extend({
	init: function(options) {
		var defaults = {
			impl: 'hrd.components.form.MultipleDateComponent',
		};
		this._super($.extend(true, {}, defaults, options));
	},
	enhanceEditField: function(field, id, klass) {
		this._super(field, id, klass);
		this.dateOptions = this.utils().date().options('multi');
		this.dateOptions.numberOfMonths = [1, 3];
		if (field.data('showOn')) {
			this.dateOptions.showOn = field.data('showOn') || 'button';
		}
		field.multiDatesPicker(this.dateOptions);
		field.parent().css('white-space', 'nowrap'); // used to avoid calendar icon on new line

		$.timeout(300)
			.then(() => this._postEnhance(field));
	},
	_postEnhance: function(field) {
		if (this.dateOptions.showOn === 'off') return;

		if (!field.usingChromaFlow()) return;

		const $trigger = this.getTrigger(field);

		$trigger.attr('data-variants', 'datepicker-addon');

		this.wrapForDatepickerAddon(field);

		const $datepicker = this.toolbox.get('datepicker.dpDiv', field.data());

		$datepicker
			.addClass('popover closed')
			.attr('data-state', 'closed');

		const position = {
			my: 'center top',
			at: 'center bottom',
			of: field,
		};

		switch (this.dateOptions.showOn) {
			case 'button':
				this.datePickerButtonHandler($trigger, $datepicker, position);
				break;
			case 'focus':
				this.datePickerFocusHandler(field, $datepicker, position);
				break;
			case 'both':
				this.datePickerButtonHandler($trigger, $datepicker, position);
				this.datePickerFocusHandler(field, $datepicker, position);
				break;
		}

		this.datePickerCloseHandler();
	},
	resetEditableField: function(field, options) {
		field.val('');
		field.multiDatesPicker('resetDates', 'picked');
	},

	/**
	 * Disable Field
	 */
	disableField: function(field, disable) {
		let method = disable ? 'disable' : 'enable';
		field.datepicker(method);
		this.getTrigger(field).button(method);
	},

	wrapForDatepickerAddon: function(field) {
		if (!field.usingChromaFlow()) return;

		const $addon = field.closest('.field-composite').find('[data-variants~="datepicker-addon"]');
		if ($addon.exists() && !$addon.closest('.addon-container').exists()) {
			$addon
				.add($addon.siblings(this.wrappableSelectors))
				.wrapAll('<div class="datepicker-addon-container addon-container field-container"></div>');
		}

		if ($addon.exists()) {
			if ($addon.nextAll(field).exists()) {
				$addon.addClass('addon-before');
				field.addClass('addon-after');
			} else if ($addon.prevAll(field).exists()) {
				field.addClass('addon-before');
				$addon.addClass('addon-after');
			}
		}
	},
	getTrigger: function(field) {
		const $trigger = field.closest('.field-composite').find('.ui-datepicker-trigger');
		return $trigger;
	},
	datePickerButtonHandler: function($trigger, $datepicker, position) {
		$trigger
			.off('.open-datepicker')
			.on('click.open-datepicker', () => {
				$datepicker
					.removeClass('ui-timepicker')
					.css({
						opacity: 1
					})
					.stop(true)
					.removeClass('closed')
					.attr('data-state', 'open');
			});
	},
	datePickerFocusHandler: function($trigger, $datepicker, position) {
		$trigger
			.off('.open-datepicker')
			.on('focus.open-datepicker', () => {
				$datepicker
					.css({
						opacity: 1
					})
					.stop(true)
					.removeClass('closed')
					.attr('data-state', 'open');
			});
	},
	datePickerCloseHandler: function() {
		let isAlreadyRegistered = $(document).hasEvent('click', 'close-multidatepicker');
		if (!isAlreadyRegistered) {
			$(document)
				.off('click.close-multidatepicker')
				.on('click.close-multidatepicker', (evt) => {
					if (
						$(evt.target).is('.hasDatepicker') ||
						$(evt.target).closest('.hasDatepicker').exists() ||
						$(evt.target).closest('.ui-datepicker').exists() ||
						$(evt.target).closest('.ui-datepicker-prev').exists() ||
						$(evt.target).closest('.ui-datepicker-next').exists()
					) return;

					$('.ui-datepicker')
						.stop(true)
						.attr('data-state', 'closed');

					$('.ui-datepicker')
						.off('.animation')
						.one('animationend.animation', (event) => {
							event.stopPropagation();

							const isClosed = $(event.target).attr('data-state') === 'closed';
							$(event.target).toggleClass('closed', isClosed);
						});
				});
		}
	}
});